import moment from 'moment';
import _ from 'underscore';
import handlebars from 'handlebars';
import jQuery from 'jquery';

import reservationExportTemplateUrl from '../printTemplates/reservationExport.html';
import fastPassInventoryTemplateUrl from '../printTemplates/fastPassInventory.html';

const TEMPLATES = {
  RESERVATION_EXPORT: reservationExportTemplateUrl,
  FAST_PASS_INVENTORY: fastPassInventoryTemplateUrl
};

class PrintService {
  constructor(managementUserService, templateService, $timeout) {
    this._managementUserService = managementUserService;
    this._templateService = templateService;
    this._$timeout = $timeout;
  }

  get TEMPLATES() { //eslint-disable-line
    return TEMPLATES;
  }

  printTemplate(template, context) {
    if (!template) throw new Error('PrintService - printTemplate() - template is required');
    if (!context) throw new Error('PrintService - printTemplate() - context is required');

    const compiledTemplate = handlebars.compile(template);
    const printHTML = compiledTemplate(context);

    console.log(context);

    this._printRenderedTemplate(printHTML);
  }

  _printRenderedTemplate(printHTML) { //eslint-disable-line
    if (!printHTML) throw new Error('PrintService - _printRenderedTemplate() - printHTML is required');

    jQuery('#printFrame').remove();

    const printFrame = jQuery('<iframe id="printFrame" name="printFrame"></iframe>');

    printFrame.on('load', () => {
      const printWindow = window.frames.printFrame;

      printWindow.document.write(printHTML);
      printWindow.focus();

      this._$timeout(() => {
        printWindow.print();

        jQuery('#printFrame').remove();
      }, 1000);
    });

    jQuery('body').append(printFrame);
  }

  /**
   * @param {Object} admissionGroup
   * @param {Object} venue
   */
  printAdmissionGroup(admissionGroup, venue) {
    if (!admissionGroup) throw new Error('PrintService - printAdmissionGroup() - admissionGroup is required');
    if (!venue) throw new Error('PrintService - printAdmissionGroup() - venue is required');

    const currentUser = this._managementUserService.getCurrentUser();
    if (!currentUser) throw new Error('printService - printAdmissionGroup() - user not found');

    //PAGE 1
    let printHTML = '';
    printHTML += getCssStyles();
    printHTML += '<div id="wrapper-page-1" class="wrapper">';
    printHTML += `<h2>${venue.name}</h2>`;
    printHTML += '<table style="margin:0; padding:0">';
    printHTML += getDateHtml(admissionGroup.date);
    printHTML += getNameHtml(admissionGroup.name);
    printHTML += getGuestsHtml(admissionGroup);
    printHTML += getMinimumSpendHtml(admissionGroup);
    printHTML += getChitHtml(venue);
    printHTML += getCompedHtml(admissionGroup);
    printHTML += getPrePaidHtml(admissionGroup);
    printHTML += getTablesHtml(admissionGroup);
    printHTML += getBookedByHtml(admissionGroup);
    printHTML += getServerHtml(admissionGroup);
    printHTML += getArrivalTimeHtml(admissionGroup);
    printHTML += getCheckedInHtml(admissionGroup);
    printHTML += getExitTimeHtml();
    printHTML += '<tr><td colspan=2 style="min-height:60px; border-bottom: 1px solid #000000;"><br/><br/> <br/> </td></tr>';
    printHTML += '<tr><td colspan=2  style="text-align:center;">Client Signature</td></tr>';
    printHTML += getSignatureHtml(venue);
    printHTML += '<tr><td colspan=2 style="min-height:60px;"><div style="min-height:60px"></div></td></tr>';
    printHTML += '</table><br/><br/>';
    printHTML += '</div>';

    //PAGE 2
    //NOTE : not sure how much margin should be used, but this seems to force it onto a second page
    printHTML += '<div id="wrapper-page-2" class="wrapper" style="margin-top: 1500px">';
    printHTML += `<h2>${venue.name}</h2>`;
    printHTML += '<table style="margin:0; padding:0">';
    printHTML += getDateHtml(admissionGroup.date);
    printHTML += getNameHtml(admissionGroup.name);
    printHTML += getGuestsHtml(admissionGroup);
    printHTML += getMinimumSpendHtml(admissionGroup);
    printHTML += getChitHtml(venue);
    printHTML += getCompedHtml(admissionGroup);
    printHTML += getPrePaidHtml(admissionGroup);
    printHTML += getTablesHtml(admissionGroup);
    printHTML += getBookedByHtml(admissionGroup);
    printHTML += getServerHtml(admissionGroup);
    printHTML += getArrivalTimeHtml(admissionGroup);
    printHTML += getCheckedInHtml(admissionGroup);
    printHTML += getExitTimeHtml();
    printHTML += getPosSyncCode(admissionGroup);
    printHTML += getNotesHtml(admissionGroup);
    printHTML += '</table><br/><br/>';
    printHTML += `<table>

    </table>`;
    printHTML += '</div>';

    console.log(printHTML);

    this._printRenderedTemplate(printHTML);
  }
}

function getCssStyles() {
  return `<style>

  body, td {
    font-size: 16px;
    font-family:arial, sans-serif;
  }

  table {
    width: 100%;
  }

  table td {
    padding: 5px 0;
  }

  table tr td:last-child {
    text-align: right;
  }

  h2, p {
    text-align: center;
    color: #000000;
  }

  .wrapper {
    width: 240px;
    min-height: 360px;
  }

  </style>`;
}

function getDateHtml(date) {
  return `<tr>
    <td>Date</td>
    <td>${moment.utc(date).format('ddd, MMM DD, YYYY')}</td>
  </tr>`;
}

function getGuestsHtml(admissionGroup) {
  return `<tr>
    <td>Guests</td>
    <td>${admissionGroup.guestsExpected} - ${admissionGroup.guestsExpectedMale}M ${admissionGroup.guestsExpectedFemale}F</td>
  </tr>`;
}

function getPrePaidHtml(admissionGroup) {
  if ((admissionGroup.paymentStatus === 'DEPOSIT' || admissionGroup.paymentStatus === 'FULL') && admissionGroup.spent) {
    return `<tr><td>Pre-paid</td><td>$ ${admissionGroup.spent}</td></tr>`;
  }

  return '';
}

function getCompedHtml(admissionGroup) {
  if (admissionGroup.comp) {
    return '<tr><td>COMPED</td></tr>';
  }

  return '';
}

function getTablesHtml(admissionGroup) {
  const tables = [];

  _.each(admissionGroup.tables, table => {
    tables.push(table.name);
  });

  return `<tr><td>Table</td><td>${tables.join()}</td></tr>`;
}

function getBookedByHtml(admissionGroup) {
  const attributionName = admissionGroup.attributionName || '';

  return `<tr>
    <td>Booked by</td>
    <td>${attributionName}</td>
  </tr>`;
}

function getServerHtml(admissionGroup) {
  const serverName = admissionGroup.serverName || '';

  return `<tr>
    <td>Server</td>
    <td>${serverName}</td>
  </tr>`;
}

function getArrivalTimeHtml(admissionGroup) {
  if (admissionGroup.arrivalTime) {
    return `<tr>
      <td>Arrival Time</td>
      <td>${moment.utc(admissionGroup.arrivalTime).format('h:mm A')}</td>
    </tr>`;
  }

  return '';
}

function getChitHtml(venue) {
  if (venue.config && venue.config.reservationChitTip) {
    return `<tr>
      <td>Service Charge</td>
      <td>${venue.config.reservationChitTip}</td>
    </tr>`;
  }

  return '';
}

function getCheckedInHtml(admissionGroup) {
  if (admissionGroup.arrived && admissionGroup.arrivedAt) {
    return `<tr>
      <td>Checked In</td>
      <td>${moment(admissionGroup.arrivedAt).format('h:mm A')}</td>
    </tr>`;
  }

  return '';
}

function getNameHtml(name) {
  name = name || '';

  return `<tr>
    <td>Name</td>
    <td>${name}</td>
  </tr>`;
}

function getExitTimeHtml() {
  return `<tr>
    <td>Exit Time</td>
    <td>__________</td>
  </tr>`;
}

function getPosSyncCode(admissionGroup) {
  if (!admissionGroup.posSyncEnabled) return '';

  return `<tr>
    <td colspan="2" style="text-align: center; font-size="20px">
      POS Code
    </td>
  </tr>
  <tr>
    <td colspan="2" style="text-align: center; font-size: 60px; font-weight: bold;">
      <h2>
      ${admissionGroup.posCode}
      </h2>
    </td>
  </tr>`;
}

function getNotesHtml(admissionGroup) {
  const notes = admissionGroup.notes || '';

  if (admissionGroup.notes) {
    return `<tr>
      <td>Notes</td>
      <td>${notes}</td>
    </tr>`;
  }

  return '';
}

function getSignatureHtml(venue) {
  const venueSignatureNotes = venue.config && venue.config.reservationChitText || 'By signing this contract the guest(s) will be held accountable to the agreed upon table minimum. Taxes and service charge are not included in the minimum, and will be added to every check. Failure to reach the minimum will result in a charge for the remaining balance. I (the guest) authorize, understand, and agree to all terms of this contract.'; //eslint-disable-line

  return `<tr><td colspan=2 style='text-align:center; font-size:10px;'>${venueSignatureNotes}</td></tr>`;
}

function getMinimumSpendHtml(admissionGroup) {
  let minCopy = '';

  if (admissionGroup.minimumSpend) {
    const minSpendDisplay = Number(admissionGroup.minimumSpend).toFixed();

    minCopy = `$ ${minSpendDisplay}`;
  } else if (admissionGroup.minimumBottles) {
    const minBottles = Number(admissionGroup.minimumBottles);
    const minBottlesDisplay = minBottles.toFixed();

    minCopy = `${minBottlesDisplay} Bottle`;

    if (minBottles > 1) minCopy += 's';
  }

  return `<tr>
    <td>Minimum</td>
    <td>${minCopy}</td>
  </tr>`;
}

PrintService.$inject = [
  'jsSdk.managementUser',
  'templateService',
  '$timeout'
];

export default PrintService;



// WEBPACK FOOTER //
// ./src/services/printService.js